"use strict";
import { useThemeName } from "@tamagui/core";
export function useIsDarkMode() {
  const themeName = useThemeName();
  return themeName.startsWith("dark");
}
